module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921103834_T.b8afdf37.jpg";